// extracted by mini-css-extract-plugin
module.exports =  {"wrapper":"a10a3f92e9--wrapper--BlOeR","title":"a10a3f92e9--title--LX7we","actions":"a10a3f92e9--actions--MuBSX","buttons":"a10a3f92e9--buttons--tizW2"};